import { EXPORTER_OFFER_PRODUCTS_TYPES } from "../types/exporterOfferProductsTypes";

export const createExportOfferProductAction = (data, id = "") => {
  return {
    type: EXPORTER_OFFER_PRODUCTS_TYPES.CREATE_EXPORTER_OFFER_PRODUCT,
    data,
    id,
  };
};
export const getExporterOfferProductsAction = (page = 1, limit = 10) => {
  return {
    type: EXPORTER_OFFER_PRODUCTS_TYPES.GET_EXPORTER_OFFER_PRODUCTS_LIST,
    page,
    limit,
  };
};

export const getOfferProductsActionForBuyer = (page = 1, limit = 10) => {
  return {
    type: EXPORTER_OFFER_PRODUCTS_TYPES.GET_OFFER_PRODUCTS_LIST_BUYER,
    page,
    limit,
  }
}

  export const deleteExporterOfferProductAction = (id) => {
    return {
      type: EXPORTER_OFFER_PRODUCTS_TYPES.DELETE_EXPORTER_OFFER_PRODUCT,
      id,
    };
  };

  export const getExporterOfferProductsById = (id) => {
    return {
      type: EXPORTER_OFFER_PRODUCTS_TYPES.GET_EXPORTER_OFFER_PRODUCT_BY_ID,
      id,
    };
  };

  export const getBuyerOfferProductsById = (id) => {
    return {
      type: EXPORTER_OFFER_PRODUCTS_TYPES.GET_BUYER_OFFER_PRODUCT_BY_ID,
      id,
    };
  }